import { units } from "@@/shared/units-and-quantities/unit";
import { repeatIndex } from "@@/utilities/repeat";
import type { BookableOptionValue } from "../../resource-reference-options/bookable-option-value";
import { isManifestBookableOption } from "../../resource-reference-options/is-manifest-bookable-option";
import {
    createManifestBookableOptionValue,
    isManifestBookableOptionValue,
} from "../../resource-reference-options/manifest-bookable-option-value";
import type { ManifestFieldType } from "../../resource-reference-options/manifest-field-type";
import { createManifestFieldValue } from "../../resource-reference-options/manifest-field-value";
import { isQuantityPickerBookableOptionValue } from "../../resource-reference-options/quantity-picker-bookable-option-value";
import type { ResourceReference } from "../../resource-references/resource-reference";

const generateAndSyncManifest = (
    filteredOnlyReserved: BookableOptionValue[],
    resourceReference: ResourceReference,
    oldManifestValues: BookableOptionValue[],
) => {
    return filteredOnlyReserved.flatMap(v => {
        const manifest = resourceReference.options.find(
            o => isManifestBookableOption(o) && o.parentId === v.parentId,
        );
        if (
            isManifestBookableOption(manifest) &&
            isQuantityPickerBookableOptionValue(v)
        ) {
            const optionValue = createManifestBookableOptionValue({
                meta: manifest.meta,
                resourceId: manifest.resourceId,
                resourceReferenceId: manifest.resourceReferenceId,
                parentId: manifest.parentId,
                manifest: repeatIndex(v.quantity.value).map(index => {
                    const oldValue = oldManifestValues.find(
                        m =>
                            isManifestBookableOptionValue(m) &&
                            m.parentId === manifest.parentId &&
                            m.manifest.find(mv => mv.index === index),
                    );

                    return createManifestFieldValue({
                        index: index,
                        data: manifest.fields.reduce(
                            (prev, current) => {
                                if (isManifestBookableOptionValue(oldValue)) {
                                    prev[current] =
                                        oldValue.manifest.find(
                                            mv => mv.index === index,
                                        )?.data[current] ?? "";
                                } else {
                                    prev[current] = "";
                                }

                                return prev;
                            },
                            {} as Record<ManifestFieldType, string>,
                        ),
                        checkedIn: false,
                    });
                }),
                // TODO! @Jakob snabbfixade här också, utifall att unit saknas
                // TODO! osäker på vad den används till också just nu, får
                // TODO! kolla senare på detta #reminder
                unit:
                    "unit" in resourceReference.resource
                        ? resourceReference.resource.unit
                        : units.pcs,
            });
            return [optionValue];
        }
        return [];
    });
};

export { generateAndSyncManifest };
